import * as Factory from 'factory.ts'
import faker from 'faker'

import { CardholderAccountStatuses } from '@webapp/modules/spending-cards/entities/enums/CardholderAccountStatusEnum'
import { CardStatuses } from '@webapp/modules/spending-cards/entities/enums/CardStatusEnum'
import { CardTypes } from '@webapp/modules/spending-cards/entities/enums/CardTypeEnum'
import { IssuingProviders } from '@webapp/modules/spending-cards/entities/enums/IssuingProvider'
import { type CardApiModel } from '../CardApiModel'

export const CardApiModelStub = Factory.Sync.makeFactory<CardApiModel>({
  id: Factory.each(() => faker.random.number()),
  external_id: Factory.each(() => faker.random.uuid()),
  cardholder: Factory.each(() => ({
    id: faker.random.number(),
    external_id: faker.random.uuid(),
    user_id: faker.random.number(),
    first_name: faker.name.firstName(),
    last_name: faker.name.lastName(),
    email: faker.internet.email(),
    department_id: faker.random.number(),
    profile_image: '',
    tos_accepted: true,
    provider: IssuingProviders.AIRWALLEX,
    status: CardholderAccountStatuses.ACTIVE,
  })),
  number: Factory.each(() => faker.finance.mask(4, false, false)),
  created_at: Factory.each(() => faker.date.past().toISOString()),
  updated_at: Factory.each(() => faker.date.past().toISOString()),
  status: CardStatuses.ACTIVE,
  category: Factory.each(() =>
    faker.random.arrayElement(Object.values(CardTypes))
  ),
  require_activation: false,
  expiry_date: Factory.each(() => faker.date.future().toISOString()),
})
